import { AddAppAccountRequestPayload } from "@/data/payload/app-account-setting/add-app-account-request-payload";
import { AppAccountSettingRepository } from "@/domain/repository/app-account-setting-repository";

export class AddAppAccountUsecase {
  constructor(private readonly repo: AppAccountSettingRepository) {}

  execute(payload: AddAppAccountRequestPayload) {
    return this.repo.addAppAccount(payload);
  }
}
